import { Store, createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import rootReducer from './reducers';

const middlewares = [
  thunkMiddleware,
];

if (process.env.NODE_ENV === 'development') {
  // TODO 暂关闭日志
  // middlewares.push(require('redux-logger').createLogger())
}

const enhancer = compose(
  applyMiddleware(...middlewares),
);

let store = createStore(rootReducer, enhancer);

export default (): Store => {
  store = createStore(rootReducer, enhancer);
  return store;
};

export const getStore = (): Store => store;
